// extracted by mini-css-extract-plugin
export default {"container":"EmojiSelector_container__0b8kl"};